import React, {Component} from 'react';
import {  Link } from 'react-router-dom'; 
  
import { base_url} from '../common/Constants';
 


 
class ExploreMore extends React.Component{
 
    render()
    { 

       // const banners = JSON.parse(localStorage.getItem("page_banners"));
        var content =  this.props.content ;
         
        return (  
        
     <div>
       
        { (this.props.services == null || this.props.services.length == 0) &&

           <section
        data-v-1294cef4=""
        data-aos="fade-up"
        data-aos-duration="1000"
        className="section-padded aos-init"
      >

         <div data-v-1294cef4="" className="explore-heading aos-init">
          EXPLORE MORE ABOUT ESTA
        </div> 


        <div className="explore" data-v-1294cef4="">
         <Link
            to={base_url+`who-we-are`}
            aria-current="page"
            className="explore-block nuxt-link-exact-active nuxt-link-active"
          >
            <img
              data-v-1294cef4=""
              src={content[18].image}
              alt={content[18].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[18].title}</h1>
            </div>
         </Link>

         <Link to={base_url+`what-we-do`} className="explore-block">
            <img
              data-v-1294cef4=""
              src={content[17].image}
              alt={content[17].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[17].title}</h1>
            </div>
         </Link>

         <Link to={base_url+`how-we-do-it`} className="explore-block">
            <img
              data-v-1294cef4=""
              src={content[16].image}
              alt={content[16].title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{content[16].title}</h1>
            </div>
         </Link>
</div>
</section>
        }

         { this.props.services &&  this.props.services.length > 0 &&

           <section
        data-v-1294cef4=""
        data-aos="fade-up"
        data-aos-duration="1000"
        className="section-padded aos-init explore-services"
      >

 <div data-v-1294cef4="" className="explore-heading aos-init ">
          EXPLORE MORE SERVICES
        </div> 
          <div className="explore" data-v-1294cef4="">

          {this.props.services.map((item, index) => (

         <Link to={base_url+`services/`+item.slug} className="explore-block">
            <img
              data-v-1294cef4=""
              src={item.image}
              alt={item.title}
              data-aos="fade-up"
              data-aos-duration="1000"
              className="aos-init"
            />
            <div
              data-v-1294cef4=""
              data-aos="fade-up"
              data-aos-duration="1000"
              className="explore-block-title aos-init"
            >
              <h1>{item.title}</h1>
            </div>
         </Link>
          ))}
</div>  

</section>
    }
 
    
</div>
      
        );
     
}

}

export default ExploreMore;